import { Theme } from '@emotion/react';

interface TranslationsVariables {
    companyName: string;
    siteName: string;
    siteUrl: string;
}

export interface CompanyData {
    theme: Theme;
    translationsResources: any;
    translationsVariables: TranslationsVariables;
    logos: LogoData;
    environmentConfig: AuthConfig;
    partnerId: string;
}

export enum LogoType {
    STANDARD = 'standard',
    SMALL = 'small',
    COMBINED = 'combined',
    SUB = 'sub',
}

export interface LogoData {
    [LogoType.STANDARD]: string;
    [LogoType.SMALL]: string;
    [LogoType.COMBINED]: string;
    [LogoType.SUB]: string;
}

export interface AuthConfig {
    issuer: string;
    clientId: string;
    webAppClientId: string;
    baseUrl: string;
}

export enum EnvironmentName {
    LOCAL = 'local',
    TEST = 'test',
    DEV = 'dev',
    QA = 'qa',
    UAT = 'uat',
    PROD = 'prod',
}

export interface EnvironmentConfig {
    [EnvironmentName.LOCAL]: AuthConfig;
    [EnvironmentName.TEST]: AuthConfig;
    [EnvironmentName.DEV]: AuthConfig;
    [EnvironmentName.QA]: AuthConfig;
    [EnvironmentName.UAT]: AuthConfig;
    [EnvironmentName.PROD]: AuthConfig;
}
